module.exports = __webpack_public_path__ + "img/yll_cover.98039ae6.png";